import script from "./AccountingFields.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountingFields.vue?vue&type=script&setup=true&lang=js"

import "./AccountingFields.vue?vue&type=style&index=0&id=190a9bbb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-190a9bbb"]])

export default __exports__